import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerExpanded: true,
  drawerOpen: false,
  dialDrawer: false,
  progressBar: false,
  helpUrl: "",
  search: false,
  searchValue: "",
};

const { actions, reducer } = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHelpUrl(state, action) {
      state.helpUrl = action.payload;
    },
    setProgressBar(state, action) {
      state.progressBar = action.payload;
    },
    setDrawerOpen(state, action) {
      state.drawerOpen = action.payload;
    },
    setDrawerExpanded(state, action) {
      state.drawerExpanded = action.payload;
    },
    setDialDrawer(state, action) {
      state.dialDrawer = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    enableSearch(state) {
      state.search = true;
    },
    disableSearch(state) {
      state.search = false;
      state.searchValue = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase("root/clearAuthData", () => {
      return initialState;
    });
  },
});

export const {
  setHelpUrl,
  setProgressBar,
  setDrawerOpen,
  setDrawerExpanded,
  setDialDrawer,
  setSearchValue,
  disableSearch,
  enableSearch,
} = actions;

export default reducer;
